import { useAuth } from 'react-oidc-context'

export const useHasRole = (roleName: string) => {
	const { isAuthenticated, user } = useAuth()

	if (!isAuthenticated || !user?.profile.role) {
		return false
	}

	if (typeof user?.profile.role === 'string' || user?.profile.role instanceof String) {
		return user?.profile.role === roleName
	}

	return !!(user?.profile.role as string[])?.find((role) => role.toLowerCase() === roleName)
}
